module.exports = __webpack_public_path__ + "fonts/Graphik-Bold.e21e62b1.ttf";